import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng9RutModule } from 'ng9-rut';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedViewsModule } from '../shared/shared-views.module';

import { FacturaManualComponent } from './factura-manual/factura-manual.component';
import { FacturaManualCabeceraComponent } from './factura-manual/factura-manual-cabecera/factura-manual-cabecera.component';
import { FacturaManualDetallesComponent } from './factura-manual/factura-manual-detalles/factura-manual-detalles.component';
import { NotaVentaComponent } from './nota-venta/nota-venta.component';
import { NotaCreditoComponent } from './nota-credito/nota-credito.component';
import { NotaDebitoComponent } from './nota-debito/nota-debito.component';
import { NotaVentaCabeceraComponent } from './nota-venta/add-nota-venta/Add-nota-venta/nota-venta-cabecera/nota-venta-cabecera.component';
import { NotaVentaDetallesComponent } from './nota-venta/add-nota-venta/Add-nota-venta/nota-venta-detalles/nota-venta-detalles.component';
import { NotaDebitoDetallesComponent } from './nota-debito/nota-debito-detalles/nota-debito-detalles.component';
import { NotaDebitoCabeceraComponent } from './nota-debito/nota-debito-cabecera/nota-debito-cabecera.component';
import { NotaCreditoCabeceraComponent } from './nota-credito/nota-credito-cabecera/nota-credito-cabecera.component';
import { NotaCreditoDetallesComponent } from './nota-credito/nota-credito-detalles/nota-credito-detalles.component';
import { ModalSeleccionDocumentoComponent } from './common/modal-seleccion-documento/modal-seleccion-documento.component';
import { ModalObservacionesComponent } from './common/modal-observaciones/modal-observaciones.component';
import { GuiaDespachoComponent } from './guia-despacho/guia-despacho.component';
import { GuiaDespachoDetallesComponent } from './guia-despacho/guia-despacho-detalles/guia-despacho-detalles.component';
import { GuiaDespachoCabeceraComponent } from './guia-despacho/guia-despacho-cabecera/guia-despacho-cabecera.component';
import { CotizacionComponent } from './cotizacion/cotizacion.component';
import { CotizacionCabeceraComponent } from './cotizacion/cotizacion-cabecera/cotizacion-cabecera.component';
import { CotizacionDetalleComponent } from './cotizacion/cotizacion-detalle/cotizacion-detalle.component';
import { AddNotaVentaComponent } from './nota-venta/add-nota-venta/Add-nota-venta/add-nota-venta.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FacturaTercerosComponent } from './factura-terceros/factura-terceros.component';
import { FacturaTercerosCabeceraComponent } from './factura-terceros/factura-terceros-cabecera/factura-terceros-cabecera.component';
import { FacturaTercerosDetallesComponent } from './factura-terceros/factura-terceros-detalles/factura-terceros-detalles.component';

@NgModule({
  declarations: [
    FacturaManualComponent,
    FacturaManualCabeceraComponent,
    FacturaManualDetallesComponent,
    NotaVentaComponent,
    NotaCreditoComponent,
    NotaDebitoComponent,
    AddNotaVentaComponent,
    NotaVentaCabeceraComponent,
    NotaVentaDetallesComponent,
    NotaDebitoDetallesComponent,
    NotaDebitoCabeceraComponent,
    NotaCreditoCabeceraComponent,
    NotaCreditoDetallesComponent,
    ModalSeleccionDocumentoComponent,
    ModalObservacionesComponent,
    GuiaDespachoComponent,
    GuiaDespachoDetallesComponent,
    GuiaDespachoCabeceraComponent,
    CotizacionComponent,
    CotizacionCabeceraComponent,
    CotizacionDetalleComponent,
    FacturaTercerosComponent,
    FacturaTercerosCabeceraComponent,
    FacturaTercerosDetallesComponent,
  ],
  exports: [FacturaManualComponent, NotaVentaComponent, NotaCreditoComponent, NotaDebitoComponent, GuiaDespachoComponent, CotizacionComponent],
  imports: [CommonModule, ToastModule.forRoot(), MDBBootstrapModulesPro.forRoot(), Ng9RutModule, FormsModule, ReactiveFormsModule, SharedViewsModule, SharedModule, NgxSpinnerModule],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class VentasModule {}
